import React from "react";
import BaseLayout from "@/Layouts/BaseLayout";
import {Breadcrumbs} from '@mui/material';
import Link from "@/Layouts/Link";
import "@/Pages/Sitemap/scss/index.scss";

const Index = (props) => {
    const {sitemapData = {}} = props;
    const {categories = {}, noCategory = []} = sitemapData;

    return (
        <BaseLayout {...props}>
            <div className={`sitemap`}>
                <div className={`container`}>
                    <Breadcrumbs maxItems={2} itemsAfterCollapse={2} className={`breadcrumbs`}>
                        <Link className={`breadcrumbs__link`} href={`/`}>Главная</Link>
                        <p className={`breadcrumbs__text`}>Карта сайта</p>
                    </Breadcrumbs>
                    <h1 className={`sitemap__h1`}>Карта сайта</h1>
                    <div className={`sitemap__content`}>
                        <div className={`sitemap__group`}>
                            {categories.map((category, i) => (
                                <div key={i} className={`sitemap__group_title`}>
                                    <h4 className={`sitemap__h4`}>
                                        <Link className={`breadcrumbs__link`} href={`${category.url}`}>
                                            {category.categoryName}
                                        </Link>
                                    </h4>
                                    {category.links.map((el) => (
                                        <Link key={el.id} className={`sitemap__group_link`} href={`${el.url}`}>
                                            {el.h1}
                                        </Link>
                                    ))}
                                </div>
                            ))}
                        </div>
                        <div className={`sitemap__group`}>
                            <div className={`sitemap__group_title`}>
                                {noCategory.map((el) => (
                                    <Link key={el.id} className={`sitemap__group_link`} href={`${el.url}`}>
                                        {el.h1}
                                    </Link>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </BaseLayout>
    );
};

export default Index;

